import React, { useState, useEffect } from "react";
import { getBackendAssetsUrl } from "./../../config/Production";

function ImageSetter({ staticfolder, image, name, size }) {
  const [backurl, setBackUrl] = useState("");
  const [folderName, setFolderName] = useState("");
  const [randomImage, setRandomImage] = useState("");
  useEffect(() => {
    if (!image) return;

    const imagesArray = image.split("|");
    const randomIndex = Math.floor(Math.random() * imagesArray.length);

    setRandomImage(imagesArray[randomIndex]);
    setFolderName(name.toLowerCase().replaceAll(" ", "_"));
    setBackUrl(getBackendAssetsUrl());
  }, [image, name]);

  if (!randomImage) return null;
  return (
    <img
      src={`${backurl}${staticfolder}/${folderName}/${randomImage}_${size}.webp`}
      alt={name}
    />
  );
}

export default ImageSetter;
